export const COLOR_TRANSPARENT = 'transparent'
export const COLOR_SELECTED = '#bce8f1'
export const SELECTED_CLASS = 'selected'
